const endpoints = {
  // setting API
  settings: { url: "/settings", method: "GET" },
  // login and profile module
  login: { url: "/login", method: "POST" },
  forgotPassword: { url: "/verify-account", method: "POST" },
  verifyOTP: { url: "/verify-otp", method: "POST" },
  resetPassword: { url: "/reset-password", method: "POST" },
  logout: { url: "/logout", method: "GET" },
  refreshToken: { url: "/refresh-token", method: "POST" },
  resend2FACode: { url: "/resend-two-factor-code", method: "POST" },
  verify2FACode: { url: "/verify-two-factor-code", method: "POST" },
  // country
  countryList: { url: "/country", method: "GET" },
  // admin users
  adminUserList: { url: "/admin-list", method: "POST" },
  addAdminUser: { url: "/admin-create", method: "POST" },
  updateAdminUser: { url: "/admin-update", method: "POST" },
  deleteAdminUser: { url: "/delete-user", method: "POST" },
  // teachers
  teacherList: { url: "/teachers", method: "POST" },
  updateTeacher: { url: "/teacher-update", method: "POST" },
  deleteUser: { url: "/delete-user", method: "POST" },
  updateUserStatus: { url: "/user-profile-active-inactive", method: "POST" },
  updateTeacherStatus: { url: "/manage-user-status", method: "POST" },
  uploadImageManager: { url: "/upload-file", method: "POST" },
  // students
  studentList: { url: "/students", method: "POST" },
  updateStudent: { url: "/student-update", method: "POST" },
  // transactions
  transactionList: { url: "/transction-history", method: "POST" },
  // send email notification
  sendEmailNotification: { url: "/push-email-notification", method: "POST" },
  allUserList: { url: "/all-users", method: "POST" },
  // dashboard
  dashboardData: { url: "/dashboard", method: "POST" },
  // profile
  getProfileDetails: { url: "/edit-profile", method: "POST" },
  updateProfile: { url: "/update-profile", method: "POST" },
  changePassword: { url: "/change-password", method: "POST" },
  // ContentPage
  contentPageList: { url: "/content-pages", method: "POST" },
  updateContentPage: { url: "/update-content-pages", method: "POST" },
  // Subscription
  subscriptionList: { url: "/subscription", method: "POST" },
  addSubscription: { url: "/create-subscription", method: "POST" },
  updateSubscription: { url: "/update-subscription", method: "POST" },
  deleteSubscription: { url: "/delete-subscription", method: "POST" },
  subscriptionTransactionList: {
    url: "/subscription-transaction",
    method: "POST",
  },
  // Mobile apps string
  mobileAppsStringList: { url: "/list-string", method: "POST" },
  addmobileAppsStringList: { url: "/create-string", method: "POST" },
  updatemobileAppsString: { url: "/update-string", method: "POST" },
  mobileAppsStringInfo: { url: "/string-info", method: "POST" },
  // manage subscription
  spCurrentSubscription: { url: "/sp-current-subscription", method: "POST" },
  spUpdateSubscription: { url: "/sp-update-subscription", method: "POST" },
};
export default endpoints;
